var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 129,
    viewBox: "0 0 158 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 30.5216C158 66.0666 100.033 129 64.4423 129C28.8518 129 0 100.185 0 64.6401C0 29.0951 28.8518 0.280148 64.4423 0.280148C100.033 0.280148 158 -5.02345 158 30.5216Z",
    fill: "url(#paint0_linear_1_17233)",
    fillOpacity: 0.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1147 84.3702V34.6494H97.2708V76.4066L104.922 70.0872V30.8247C104.922 28.7128 103.21 27 101.098 27H53.29C51.1781 27 49.4668 28.7128 49.4668 30.8247V88.1934C49.4668 90.3053 51.1781 92.0181 53.29 92.0181H86.6636L81.2572 84.3702H57.1147Z",
    fill: "url(#paint1_linear_1_17233)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.934 68.1197C115.229 67.4554 114.146 67.4241 113.405 68.0348L95.8631 82.5322L84.1731 75.5188C83.3971 75.0541 82.4037 75.1926 81.7856 75.8599C81.172 76.5212 81.105 77.5235 81.6277 78.2622L94.2963 96.1897C94.6507 96.6916 95.2271 96.9924 95.8407 96.9984C95.8467 96.9984 95.8526 96.9984 95.8586 96.9984C96.4663 96.9984 97.0397 96.7109 97.4001 96.2165L116.166 70.6397C116.732 69.8637 116.635 68.7839 115.934 68.1197Z",
    fill: "url(#paint2_linear_1_17233)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6683 40.3862H65.7187C63.6068 40.3862 61.8955 42.099 61.8955 44.2109C61.8955 46.3228 63.6068 48.0356 65.7187 48.0356H88.6668C90.7787 48.0356 92.4885 46.3228 92.4885 44.2109C92.4885 42.099 90.7802 40.3862 88.6683 40.3862Z",
    fill: "url(#paint3_linear_1_17233)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6683 51.8589H65.7187C63.6068 51.8589 61.8955 53.5717 61.8955 55.6836C61.8955 57.7955 63.6068 59.5082 65.7187 59.5082H88.6668C90.7787 59.5082 92.4885 57.797 92.4885 55.6836C92.493 53.5717 90.7802 51.8589 88.6683 51.8589Z",
    fill: "url(#paint4_linear_1_17233)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6683 63.333H65.7187C63.6068 63.333 61.8955 65.0458 61.8955 67.1577C61.8955 69.2696 63.6068 70.9824 65.7187 70.9824H88.6668C90.7787 70.9824 92.4885 69.2696 92.4885 67.1577C92.493 65.0458 90.7802 63.333 88.6683 63.333Z",
    fill: "url(#paint5_linear_1_17233)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_17233",
    x1: 79,
    y1: 0,
    x2: 79,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_17233",
    x1: 77.1942,
    y1: 27,
    x2: 77.1942,
    y2: 92.0181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_17233",
    x1: 98.9048,
    y1: 67.5981,
    x2: 98.9048,
    y2: 96.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_17233",
    x1: 77.192,
    y1: 40.3862,
    x2: 77.192,
    y2: 48.0356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_17233",
    x1: 77.192,
    y1: 51.8589,
    x2: 77.192,
    y2: 59.5082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_17233",
    x1: 77.192,
    y1: 63.333,
    x2: 77.192,
    y2: 70.9824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CF83"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMatches);
export default __webpack_public_path__ + "static/media/no-matches.cc45434afdaa37ac7b9fef7e474079e8.svg";
export { ForwardRef as ReactComponent };